module.exports = __webpack_public_path__ + "static/media/slack.505f3eed.png";